var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairDryer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Hair dryer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.90133 2.16901C3.83378 1.29191 1 3.94925 1 7.34975C1 10.7503 3.83378 13.4076 6.90133 12.5324C7.47991 12.3589 10.7479 11.4925 11.312 11.273C12.0241 11.0265 14.2356 10.8275 15.579 10.7207C16.0994 10.6793 16.5 10.247 16.5 9.72501V4.97516C16.5 4.45363 16.1001 4.02178 15.5803 3.98027C14.237 3.87304 12.0241 3.67399 11.3111 3.42746C10.7467 3.20793 7.47932 2.34153 6.90044 2.16808L6.90133 2.16901ZM8.14044 13.8792C8.65743 13.7265 9.16889 13.554 9.67378 13.362C9.78045 13.7601 11 14.5 11 16C11 17.5 9.18933 19.2097 9.18933 19.2097H8.55556V21.3024C8.55556 21.4874 8.48532 21.6649 8.36029 21.7957C8.23527 21.9265 8.0657 22 7.88889 22H3.44444V20.6048H7.22222V19.2097H5.45778L5.44444 18.5269C5.424 17.541 5.39556 16.1645 5.22578 14.8762C5.18044 14.5302 5.12533 14.1963 5.05867 13.8829C6.06678 14.1777 7.13299 14.1764 8.14044 13.8792Z",
    fill: "#152946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1095",
    d: "M19 5.44444C19 5.44444 19.5 4.44454 20.5 5.44444C21.5 6.44434 22.5 5.44435 22.5 5.44435",
    stroke: "#152946",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1095_2",
    d: "M19 7.83311C19 7.83311 19.5 6.83321 20.5 7.83311C21.5 8.83301 22.5 7.83302 22.5 7.83302",
    stroke: "#152946",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1095_3",
    d: "M19 10.2223C19 10.2223 19.5 9.22237 20.5 10.2223C21.5 11.2222 22.5 10.2222 22.5 10.2222",
    stroke: "#152946",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairDryer);
export default __webpack_public_path__ + "static/media/hair-dryer.cca5ba2defd1f2e36523ad190d7ef6f1.svg";
export { ForwardRef as ReactComponent };